//#region Required Components for Top Nav
import VSTSFeeWaiverTermsPage from "pages/FeeWaiverTerms/VSTSFeeWaiverTermsPage";
import VSTTFeeWaiverTermsPage from "pages/FeeWaiverTerms/VSTTFeeWaiverTermsPage";
import DafStaticPage from "../pages/Static/Daf";
import VsttStaticPage from "../pages/Static/VsttAbout";
import Library from "../pages/Library/Library";
import OverviewStaticPage from "../pages/Static/Overview";
import TermsOfUsePage from "../pages/TermsOfUse/TermsOfUsePage";
import SearchPage from "../pages/Search/SearchPage";
import FaqAPage from "../pages/Admin/FeeWaiver/Faq/FaqAPage";
import FaqBPage from "../pages/Admin/FeeWaiver/Faq/FaqBPage";
import FaqCPage from "../pages/Admin/FeeWaiver/Faq/FaqCPage";
import ApprovedProductsPublic from "../pages/ApprovedProducts/ApprovedProductsPublic";
import GettingStartedPage from "pages/GettingStarted/GettingStartedPage";
//#endregion

//#region  Default Routes
let home = "";
let homeNavigation = home; // fix bug 188118 Error when Reload is clicked in PROD
if (process.env.REACT_APP_HOME) {
  home = "/" + process.env.REACT_APP_HOME;
  homeNavigation = home + "/";
}
export const HOME = home;
export const HOME_NAVIGATION = homeNavigation;
export const DENIED = HOME + "/access-denied";
export const FORBIDDEN = HOME + "/403";
export const NOTFOUND = HOME + "/404";
export const ACCESS_DNIED = "./Account/AccessDenied";
export const VOL_HOME = "" + process.env.REACT_APP_VOLHOME;
//#endregion

// Public Routes
export const LIBRARY = HOME + "/library";
export const GETTING_STARTED = HOME + "/GettingStartedPage";
export const LIBRARY_VISA_SECURE_TEST_TOOLS = HOME + "/library/VisaSecureTestTools";
export const SUBSCRIBING_VSTT_GUIDE = HOME + "/library?filters=VSTT";
export const VSTT_MERCHANT_SUPPORTED_TESTCASES = HOME + "/library/VisaSecureTestTools";

export const VISASECURERELEASES = HOME + "/VisaSecureReleases";
export const VISASECURETESTING = HOME + "/VisaSecureTesting";
export const THREEDSCERTIFICATES = HOME + "/3DSCertificates";
export const USINGVISASECURESERVICES = HOME + "/UsingVisaSecureServices";
export const TERMS_OF_USE_PATHNAME = "TermsOfUse";
export const TERMS_OF_USE = HOME + "/" + TERMS_OF_USE_PATHNAME;
export const VSTS_FEE_WAIVER_TERMS_PATHNAME = "VSTSFeeWaiverTerms";
export const VSTS_FEE_WAIVER_TERMS =
  HOME + "/" + VSTS_FEE_WAIVER_TERMS_PATHNAME;
export const VSTT_FEE_WAIVER_TERMS_PATHNAME = "VSTTFeeWaiverTerms";
export const VSTT_FEE_WAIVER_TERMS =
  HOME + "/" + VSTT_FEE_WAIVER_TERMS_PATHNAME;
export const PUBLIC_OVERVIEW = HOME + "/overview";
export const PUBLIC_DAF = HOME + "/daf";
export const PUBLIC_VSTT = HOME + "/vsttabout/";
export const SEARCH_PAGE = HOME + "/search";

export const WHATISVSTT = PUBLIC_VSTT + "#WhatIsVSTT?";
export const VSTTTESTMERCHANT = PUBLIC_VSTT + "#VSTTTestMerchant";
export const VSTTTESTACS = PUBLIC_VSTT + "#VSTTTestACS";
export const BEFOREYOUBEGIN = PUBLIC_VSTT + "#BeforeYouBegin";
export const HOWTOENROLL = PUBLIC_VSTT + "#HowToEnroll?";
export const VSTTRESOURCES = PUBLIC_VSTT + "#Resources";

const APPROVED_PRODUCTS_PUBLIC = HOME + "/ApprovedProducts";
const APPROVED_PRODUCTS_ALL = HOME + "/ApprovedProductsAll";
export const APPROVEDPRODUCTS = {
  APPROVED_PRODUCTS_ALL,
  APPROVED_PRODUCTS_PUBLIC,
};

//#region Admin Routes
const ADMIN = HOME + "/admin";
export const ANNOUNCEMENT = ADMIN + "/announcement";
const ACCESSREQUEST = ADMIN + "/access";
const EMAILNOTIFICATION = ADMIN + "/emailnotification";
const EMAILNOTIFICATION_SETTINGS = ADMIN + "/emailnotification/settings";

const MANAGEUSERS = ADMIN + "/users";
const MANAGEORGANIZATIONS = ADMIN + "/organizations";
const MANAGEORGANIZATION_DETAILS = ADMIN + "/organization/details";
const MANAGELIBRARY = ADMIN + "/library";
const MANAGELIBRARY_CATEGORY = ADMIN + "/library/category";
const MANAGELIBRARY_POST = ADMIN + "/library/object";
const MANAGELIBRARY_TAG = ADMIN + "/library/tag";
const MANAGELIBRARY_POSTACCESSHISTORY = ADMIN + "/library/objectaccesshistory";

const MANAGEBILLINGLINES = ADMIN + "/billinglines";
const MANAGEBILLINGLINES_DETAILS = ADMIN + "/billinglines/details";
const MANAGEBILLINGFILES_GENERATEMANUAL = ADMIN + "/billinglines/generate";
const MANAGEBILLINGLINES_REVIEW = ADMIN + "/billinglines/review";

const MANAGEFEEWAIVERS = ADMIN + "/feewaivers";

const FAQ_A = ADMIN + "/feewaiver/FaqA";
const FAQ_B = ADMIN + "/feewaiver/FaqB";
const FAQ_C = ADMIN + "/feewaiver/FaqC";

const MANAGESUBSCRIPTION_ORDER = ADMIN + "/subscription/order";
const MANAGESUBSCRIPTION_ORDER_DETAILS = ADMIN + "/subscription/order/details";
const MANAGESUBSCRIPTION = ADMIN + "/subscription";
const MANAGESUBSCRIPTION_DETAILS = ADMIN + "/subscription/details";

export const AdminRoutes = {
  ANNOUNCEMENT,
  ACCESSREQUEST,
  EMAILNOTIFICATION,
  EMAILNOTIFICATION_SETTINGS,
  MANAGEUSERS,
  MANAGEORGANIZATIONS,
  MANAGEORGANIZATION_DETAILS,
  MANAGELIBRARY,
  MANAGELIBRARY_CATEGORY,
  MANAGELIBRARY_POST,
  MANAGELIBRARY_TAG,
  MANAGELIBRARY_POSTACCESSHISTORY,
  MANAGEBILLINGLINES,
  MANAGEBILLINGLINES_DETAILS,
  MANAGEBILLINGLINES_REVIEW,
  MANAGEBILLINGFILES_GENERATEMANUAL,
  MANAGEFEEWAIVERS,
  MANAGESUBSCRIPTION_ORDER,
  MANAGESUBSCRIPTION_ORDER_DETAILS,
  MANAGESUBSCRIPTION,
  MANAGESUBSCRIPTION_DETAILS,
  FAQ_A,
  FAQ_B,
  FAQ_C,
};

//#endregion

//#region  External User Rotues
const USER_ANNOUNCEMENT = HOME + "/announcements";

const STORE_PURCHASE = HOME + "/store";
const SUBSCRIPTIONS = STORE_PURCHASE + "/subscriptions";
const SUBSCRIPTION_DETAILS = STORE_PURCHASE + "/subscriptions/details";
//const STORE_ACCOUNT_INFO = STORE_PURCHASE + "/info";

export const AuthenticatedExternalUserRoutes = {
  USER_ANNOUNCEMENT,
  STORE_PURCHASE,
  SUBSCRIPTIONS,
  //STORE_ACCOUNT_INFO,
  SUBSCRIPTION_DETAILS,
};
//#endregion

// region: Certification Workflow Routes
const CERTIFICATION_WORKFLOW = HOME + "/certification";

const CERTIFICATION_PACKAGES_LIST = CERTIFICATION_WORKFLOW + "/allpackages";
const CERTIFICATION_PACKAGES_INFO = CERTIFICATION_WORKFLOW + "/packageinfo/:packageId";
export const CERTIFICATION_PACKAGES_INFO_WITH_ID = (id) => CERTIFICATION_WORKFLOW + `/packageinfo/${id}`;

const CERTIFICATION_VSTS_ACCESS = "/VstsWeb/GetVstsAccess";

export const CertificationWorkflowRoutes = {
  CERTIFICATION_PACKAGES_LIST,
  CERTIFICATION_VSTS_ACCESS,
  CERTIFICATION_PACKAGES_INFO
};
// endregion

//#region User Settings Routes
const USER_SETTINGS = HOME + "/settings";

const USER_ACCOUNT_INFO = USER_SETTINGS + "/account";
const USER_EMAIL_NOTIFICATION = USER_SETTINGS + "/emailnotification";

const USER_EMAIL_NOTIFICATION_SELECTED = USER_EMAIL_NOTIFICATION + `/selectedVssClients`;
export const USER_EMAIL_NOTIFICATION_SELECTED_VSSCLIENTS = USER_EMAIL_NOTIFICATION_SELECTED;

const COMPANY_CONTACTS = USER_SETTINGS + "/companycontacts";

export const UserSettingRoutes = {
  USER_ACCOUNT_INFO,
  USER_EMAIL_NOTIFICATION,
  USER_EMAIL_NOTIFICATION_SELECTED,
  COMPANY_CONTACTS,
};
//#endregion
export const RESOURCES = HOME + "/resources"

const DAF_UPLOAD = HOME + "/dafupload";
const DAF_UPLOAD_LIST = HOME + "/dafupload/list";
const DAF_UPLOAD_REQUEST = HOME + "/dafupload/request";

export const DafUploadRoutes = {
  DAF_UPLOAD,
  DAF_UPLOAD_LIST,
  DAF_UPLOAD_REQUEST,
};

const DAF_VMID_LIST = HOME + "/dafvmid/list";
const DAF_ACQUIRER_VMID_LIST = HOME + "/dafacquirervmid/list";

export const DafVmidRoutes = {
  DAF_VMID_LIST,
  DAF_ACQUIRER_VMID_LIST,
};

export const PUBLIC_ROUTES = [
  {
    redirect: TERMS_OF_USE,
    component: TermsOfUsePage,
    exact: false, // may have additional path, for example: /TermsOfUse/v1/tou_us
  },
  {
    redirect: VSTS_FEE_WAIVER_TERMS,
    component: VSTSFeeWaiverTermsPage,
    exact: false,
  },
  {
    redirect: VSTT_FEE_WAIVER_TERMS,
    component: VSTTFeeWaiverTermsPage,
    exact: false,
  },
];

/* Before VOL login, the routes are included RouteHelper.Flattened_Public_Routes */
/* After VOL login, the routes are included in AUTHENTICATED_PAGES */
export const PUBLIC_ROUTES_BEFORE_VOL_LOGIN = [
  {
    redirect: LIBRARY,
    component: Library,
  },
  {
    redirect: GETTING_STARTED,
    component: GettingStartedPage,
  },
  {
    redirect: VSTT_MERCHANT_SUPPORTED_TESTCASES,
    component: Library, //should be somehting else
  },
  {
    redirect: SUBSCRIBING_VSTT_GUIDE,
    component: GettingStartedPage, // should be something else
  },
  {
    redirect: LIBRARY_VISA_SECURE_TEST_TOOLS,
    component: Library, 
  },
  {
    redirect: PUBLIC_OVERVIEW,
    component: OverviewStaticPage,
  },
  {
    redirect: PUBLIC_DAF,
    component: DafStaticPage,
  },
  {
    redirect: PUBLIC_VSTT,
    component: VsttStaticPage,
  },
  {
    redirect: SEARCH_PAGE,
    component: SearchPage,
  },
  {
    redirect: APPROVED_PRODUCTS_PUBLIC,
    component: ApprovedProductsPublic,
  },
];

export const AUTHENTICATED_ROUTES_NO_NAV = [
  {
    redirect: FAQ_A,
    component: FaqAPage,
  },
  {
    redirect: FAQ_B,
    component: FaqBPage,
  },
  {
    redirect: FAQ_C,
    component: FaqCPage,
  },
];

export const ADMIN_PAGES = [
  ANNOUNCEMENT,
  ACCESSREQUEST,
  EMAILNOTIFICATION,
  EMAILNOTIFICATION_SETTINGS,
  MANAGEUSERS,
  MANAGEORGANIZATIONS,
  MANAGEORGANIZATION_DETAILS,
  MANAGELIBRARY,
  MANAGELIBRARY_CATEGORY,
  MANAGELIBRARY_POST,
  MANAGELIBRARY_TAG,
  MANAGELIBRARY_POSTACCESSHISTORY,
  MANAGEBILLINGLINES,
  MANAGEBILLINGLINES_DETAILS,
  MANAGEBILLINGLINES_REVIEW,
  MANAGEFEEWAIVERS,
  MANAGESUBSCRIPTION_ORDER,
  MANAGESUBSCRIPTION_ORDER_DETAILS,
  MANAGESUBSCRIPTION,
  MANAGESUBSCRIPTION_DETAILS,
];

export const AUTHENTICATED_PAGES = [
  HOME,
  LIBRARY,
  GETTING_STARTED,
  SUBSCRIBING_VSTT_GUIDE,
  VSTT_MERCHANT_SUPPORTED_TESTCASES,
  LIBRARY_VISA_SECURE_TEST_TOOLS,
  PUBLIC_DAF,
  PUBLIC_OVERVIEW,
  PUBLIC_VSTT,
  STORE_PURCHASE,
  SUBSCRIPTIONS,
  SUBSCRIPTION_DETAILS,
  DAF_UPLOAD,
  DAF_UPLOAD_LIST,
  DAF_UPLOAD_REQUEST,
  DAF_VMID_LIST,
  DAF_ACQUIRER_VMID_LIST,
  USER_ACCOUNT_INFO,
  USER_EMAIL_NOTIFICATION,
  USER_EMAIL_NOTIFICATION_SELECTED,
  SEARCH_PAGE,
  APPROVED_PRODUCTS_PUBLIC,
  APPROVED_PRODUCTS_ALL,
  COMPANY_CONTACTS,
  RESOURCES,
  CERTIFICATION_PACKAGES_INFO,
  CERTIFICATION_PACKAGES_LIST,
  CERTIFICATION_VSTS_ACCESS,
];
